import React from 'react'
import { Link } from 'react-router-dom'

// Standard header for any review surface.
// Eyebrow tells the user which review concept they're looking at:
//   - product:  "Məhsul rəyi"
//   - seller:   "Satıcı rəyi"
//   - platform: "Platforma rəyi"
//
// Props:
//   surface: 'product' | 'seller' | 'platform'
//   title, subtitle: strings
//   action: { to, label }  optional CTA

const SURFACE = {
    product:  { label: 'Məhsul rəyi',   chip: 'bg-success-50 text-success-700'  },
    seller:   { label: 'Satıcı rəyi',   chip: 'bg-accent-50 text-accent-700'    },
    platform: { label: 'Platforma rəyi', chip: 'bg-brand-50 text-brand-700'     },
}

const Arrow = () => (
    <svg className='w-4 h-4 transition-transform group-hover:translate-x-1' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
    </svg>
)

const ReviewSurfaceHeader = ({
    surface = 'platform',
    title,
    subtitle,
    action,
    className = '',
}) => {
    const cfg = SURFACE[surface] || SURFACE.platform

    return (
        <div className={`mb-4 flex flex-wrap items-end justify-between gap-3 ${className}`}>
            <div className='min-w-0'>
                <span className={`inline-flex items-center rounded-pill px-3 py-1 text-[10px] font-bold uppercase tracking-wider ${cfg.chip}`}>
                    {cfg.label}
                </span>
                {title && (
                    <h2 className='mt-2 text-xl sm:text-lg font-black text-slate-900 leading-tight'>
                        {title}
                    </h2>
                )}
                {subtitle && (
                    <p className='mt-1 text-sm text-slate-500 max-w-xl'>{subtitle}</p>
                )}
            </div>
            {action?.to && (
                <Link
                    to={action.to}
                    className='group inline-flex items-center gap-1.5 rounded-card border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:border-brand-400 hover:text-brand-700'
                >
                    {action.label || 'Hamısına bax'}
                    <Arrow />
                </Link>
            )}
        </div>
    )
}

export default ReviewSurfaceHeader
